import { render, staticRenderFns } from "./sidebar-menu.vue?vue&type=template&id=81927bce&scoped=true&"
import script from "./sidebar-menu.vue?vue&type=script&lang=js&"
export * from "./sidebar-menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-menu.vue?vue&type=style&index=0&id=81927bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81927bce",
  null
  
)

export default component.exports